<template>
  <div class="layout" id="myComponentDiv">
    <div class="box-titulo">Reporte de Facturas Electrónicas MX</div>
    <div class="box-container">
      <div class="box-filtres">
        <table>
          <tbody>
            <tr>
              <td width="150px">
                <input id="fechainicio" placeholder="Fecha inicio" datatype="fecha" type="text" class="form-control"
                  autocomplete="off" v-on:change="trigger()" />
              </td>
              <td width="150px">
                <input id="fechafin" placeholder="Fecha final" datatype="fecha" type="text" class="form-control"
                  autocomplete="off" v-on:change="trigger()" />
              </td>
              <td width="150px">
                <select v-model="tipo" class="form-control">
                  <option value="1">ACTIVAS</option>
                  <option value="2">ANULADAS</option>
                  <option value="3">TODAS</option>
                  <option value="4">NC PARCIALES</option>
                </select>
              </td>
              <td>
                <button class="btn btn-warning" type="submit" @click="getReporteEquipos">
                  Consultar
                </button>
              </td>
              <td>
                <div v-if="loading">
                  <img src="dist/img/kubber-loading.gif" style="width: 30px" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div id="containter-table" class="containter-table">
        <table id="table2" width="100%" class="display nowrap" style="width: 100%">
          <thead>
            <tr>
              <th width="130px">Fecha ELE</th>
              <th width="100px">Consecutivos</th>
              <th class="text-center">Nit</th>
              <th>Cliente</th>
              <th class="text-center">Productos</th>
              <th class="text-center">Cantidad</th>
              <th class="text-center">Cantidad m3</th>
              <th class="text-center">Venta</th>
              <th>Anterior</th>
              <th class="text-center">Código</th>
              <th width="80px" class="text-center">Estado</th>
              <th width="30px" class="text-center">Acciones</th>
            </tr>
          </thead>
        </table>
      </div>
      <div>
        <table width="300px" class="table font-oswald">
          <tbody>
            <tr>
              <td class="subtable" width="150px">TRANSACCIONES</td>
              <td class="subtable b text-right">
                {{ totalventas }}
              </td>
            </tr>
            <tr>
              <td class="subtable">TOTAL CANTIDAD</td>
              <td class="subtable b text-right">
                {{ fcantidad }}
              </td>
            </tr>
            <tr>
              <td class="subtable">TOTAL CANTIDAD M3</td>
              <td class="subtable b text-right">
                {{ fcantidadM3 }}
              </td>
            </tr>
            <tr>
              <td class="subtable">TOTAL IMPUESTOS</td>
              <td class="subtable b text-right">
                {{ ftotalimpuestos }}
              </td>
            </tr>
            <tr>
              <td class="subtable">TOTAL VENTAS</td>
              <td class="subtable b text-right">
                {{ ftotales }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import GLOBAL from "../../Global.js";
import ReporteService from "../../service/ReporteService";

export default {
  data() {
    return {
      GLOBAL,
      reporteService: null,
      person: null,
      empresa: "",
      cache: false,
      permiso_lista: false,
      reporte: [],
      totalventas: 0,
      totalimpuestos: 0,
      totales: 0,
      ftotalimpuestos: "$ 0",
      ftotales: "$ 0",
      totalCantidad: 0,
      totalCantidadM3: 0,
      fcantidad: "0",
      fcantidadM3: "0",
      fecha_inicio_reporte: "",
      fecha_final_reporte: "",
      tipo: "1",
      loading: true,
      datatable: null,
    };
  },

  computed: {
    isMX() { return this.GLOBAL.COUNTRY === "MX"; },
    isCO() { return this.GLOBAL.COUNTRY === "CO"; }
  },

  created() {
    this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));
    if (GLOBAL.COUNTRY == "MX") {
      this.FACTOR_CONVERSION = this.person.parametros.factor_m3;
    }
    this.empresa = this.person.empresas;
    this.permiso_lista = this.person.funciones.includes(
      GLOBAL.PERMISOS.REPORTE.HOROMETRO
    );
    this.reporteService = new ReporteService();
    this.reporte = [];
  },

  mounted() {
    this.reporte = [];
    this.initDateInputs();
    var fechaActual = new Date();
    var vm = this;

    this.datatable = $("#table2").DataTable({
      data: this.reporte,
      responsive: true,
      autoWidth: false,
      scrollX: true,
      scrollCollapse: true,
      columns: [
        { data: "fecha" },
        {
          data: null,
          render: function (data, type, row) {
            return row.prefijo + "-" + row.consecutivo;
          },
        },
        { data: "tercero_nit", class: "text-right" },
        { data: "tercero_nombre" },
        {
          render: (data, type, row) => {
            const m = new Map();
            (row.productos || []).forEach(p => {
              const k = p._id;
              if (!m.has(k)) m.set(k, { ...p });
              else m.get(k).cantidad += p.cantidad;
            });

            const parts = [];
            for (const p of m.values()) {
              const cant = this.GLOBAL.FORMATO_NUMBER(p.cantidad);
              const unidad = `<span class='font11'>${p.unidad_codigo}</span>`;
              let line = `[${cant}${unidad}] ${p.producto_nombre}`;
              parts.push(line);
            }
            return parts.join("<br/>");
          }
        },
        {
          class: "text-right",
          render: (data, type, row) => {
            if (!row.productos || row.productos.length === 0) return "-";
            const totalCantidad = row.productos[0].cantidad;
            return this.GLOBAL.FORMATO_NUMBER(totalCantidad);
          }
        },
        {
          class: "text-right",
          render: (data, type, row) => {
            if (!row.productos || row.productos.length === 0) return "-";
            const totalCantidad = row.productos[0].cantidad / row.factor_m3;
            return this.GLOBAL.FORMATO_NUMBER(totalCantidad, 4);
          }
        },
        {
          class: "text-right",
          render: function (data, type, row) {
            return GLOBAL.FORMATO_MONEY(row.venta_total);
          },
        },
        {
          render: function (data, type, row) {
            return "";
          },
        },
        {
          class: "text-right",
          render: function (data, type, row) {
            if (GLOBAL.COUNTRY == "MX") {
              return row.public_hasp;
            } else {
              return "";
            }
          },
        },
        {
          render: (data, type, row) => this.estadoTexto(row, fechaActual),
        },
        {
          render: function (data, type, row) {
            return "";
          },
        },
      ],
      createdRow: function (row, data, dataIndex) {
        const vm = this; // Asegúrate de que `this` apunte al contexto de Vue
        const columnaAcciones = 11; // Índice de la columna de "Acciones"
        const host = GLOBAL.SERVER_HOST;
        const empresa = vm.empresa;

        // Solo agregar botones si la factura está emitida y tiene un hash público
        if (GLOBAL.COUNTRY === "MX" && data.estado === "G" && data.public_hasp != null) {
          // Botón Ver PDF
          const viewPDF = $("<a>", {
            class: "btn btn-sm btn-danger",
            target: "_blank",
            html: "<i class='fa-solid fa-file-pdf'></i>",
            href: `${host}/kubber/facturacion/api/v1/generate/${data.eid}/${data.uniqueid}`
          });

          // Botón Ver XML
          const viewXML = $("<a>", {
            class: "btn btn-sm bg-purple",
            target: "_blank",
            html: "<i class='fa-solid fa-code'></i>",
            href: `${host}/kubber/facturacion/api/v1/generatexml/${data.eid}/${data.uniqueid}`
          });

          // Agregar los botones a la columna de "Acciones"
          $("td", row).eq(columnaAcciones).append(viewPDF).append(viewXML);
        }
      },
      dom:
        "<'btt row'<'col-sm-2'l><'col-sm-4'B><'col-sm-6'f>>" +
        "<'row'<'col-sm-12'tr>>" +
        "<'btt row'<'col-sm-5'i><'col-sm-7'p>>",
      buttons: [
        {
          extend: "copyHtml5",
          text: '<i class="fa-regular fa-clipboard"></i>',
        },
        {
          extend: "excelHtml5",
          text: '<i class="fa-regular fa-file-excel"></i>',
        },
        {
          extend: "csvHtml5",
          text: '<i class="fa-solid fa-file-csv"></i>',
        },
        {
          extend: "pdfHtml5",
          text: '<i class="fa-regular fa-file-pdf"></i>',
        },
      ],
      scrollX: true,
      responsive: false,
      autoWidth: true,
      language: {
        url: "plugins/Spanish.json",
      },
    });

    this.getReporteEquipos();
  },

  methods: {
    estadoTexto(row, fechaActual) {
      const base = {
        "P": "PENDIENTE",
        "B": "REVISAR/ANULAR",
        "R": "REVISAR",
        "C": "CANCELADA",
        "I": "ANULADA",
        "X": "PRUEBAS"
      };

      if (row.estado === "A") {
        let estado = "EMITIDA";
        const fechaRow = new Date(row.fecha);
        const minutos = (fechaActual - fechaRow) / (1000 * 60);
        if (row.documento_id === this.GLOBAL.DOCUMENTO.PREFORMA) {
          estado = minutos >= 5 ? "REVISAR" : "EN PROCESO...";
        }
        return estado;
      }

      if (row.estado === "G") {
        return row.public_hasp == null ? "PENDIENTE" : "EMITIDA";
      }

      return base[row.estado] ?? row.estado;
    },

    ymdHM(date, end = false) {
      const pad = n => n.toString().padStart(2, "0");
      const y = date.getFullYear();
      const m = pad(date.getMonth() + 1);
      const d = pad(date.getDate());
      return `${y}-${m}-${d} ${end ? "23:59" : "00:00"}`;
    },

    initDateInputs() {
      const now = new Date();
      $("#fechainicio").val(this.ymdHM(now, false));
      $("#fechafin").val(this.ymdHM(now, true));
      $("input[datatype='fecha']").datetimepicker();
    },

    async getReporteEquipos() {
  this.datatable.page(0).draw(false);
  this.reporte = [];
  const fechainicio = $("#fechainicio").val();
  const fechafin = $("#fechafin").val();
  this.loading = true;

  try {
    const data = await this.reporteService.getListaMovimientosDocumentosGNV(
      this.person, fechainicio, fechafin, this.tipo
    );
    this.reporte = Array.isArray(data) ? data : [];

    const agg = this.reporte.reduce((a, r) => {
      // Validar que productos y factor_m3 existan y no sean nulos
      const cantidad = r.productos && r.productos.length > 0 && r.factor_m3
        ? r.productos[0].cantidad / r.factor_m3
        : 0;

      return {
        totalimpuestos: a.totalimpuestos + (r.impuesto_total || 0),
        totalCantidad: a.totalCantidad + cantidad,
        totalCantidadM3: a.totalCantidadM3 + (cantidad / r.factor_m3),
        totales: a.totales + (r.venta_total || 0),
        totalventas: a.totalventas + 1
      };
    }, { totalimpuestos: 0, totalCantidad: 0, totalCantidadM3:0, totales: 0, totalventas: 0 });

    Object.assign(this, {
      totalimpuestos: agg.totalimpuestos,
      totalCantidad: agg.totalCantidad,
      totalCantidadM3: agg.totalCantidadM3,
      totales: agg.totales,
      totalventas: agg.totalventas,
      fcantidad: this.GLOBAL.FORMATO_NUMBER(agg.totalCantidad),
      fcantidadM3: this.GLOBAL.FORMATO_NUMBER(agg.totalCantidadM3),
      ftotalimpuestos: this.GLOBAL.FORMATO_MONEY(agg.totalimpuestos),
      ftotales: this.GLOBAL.FORMATO_MONEY(agg.totales),
      fecha_inicio_reporte: fechainicio,
      fecha_final_reporte: fechafin
    });

    this.datatable.clear().rows.add(this.reporte).draw();
  } finally {
    this.loading = false;
  }
}

    
  },
};
</script>

<style scoped>
.btn-loading {
  pointer-events: none !important;
  opacity: 0.9;
}

.btn-loading i {
  animation: spinPulse 1s infinite;
  display: inline-block;
}

.btn-white {
  background-color: #406b00;
  color: #ffffff;
  border: 1px solid #cccccc;
}

@keyframes spinPulse {
  0% {
    transform: rotate(0deg) scale(1);
  }

  100% {
    transform: rotate(360deg) scale(1);
  }
}
</style>
